import { AppDispatch } from '..';
import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';
import { getBalanceBySubReportId } from '../selectors/balance';
import { getContentByEntityId } from '../selectors/content';
import balance from '../slices/balance';
import content from '../slices/content';

export const dispatchBalanceEditValues = (
  result: Record<string, any>,
  datasetId: UniqueId,
  state: AppState,
  dispatch: AppDispatch
): void => {
  const balanceId = getBalanceBySubReportId(state, result.subReportId);
  if (balanceId) {
    const contentId = getContentByEntityId(state, balanceId);
    if (contentId) {
      dispatch(content.activate({ id: contentId }));
    }
  } else {
    dispatch(
      balance.open({
        datasetId,
        streamId: result.data.id,
        templateId: result.templateId,
        reportId: result.reportId,
        subReportId: result.subReportId,
        formName: result.formName,
        title: result.title,
        indexes: result.indexes,
        records: result.records,
        values: result.values,
        options: result.options,
      })
    );
  }
};
